import * as React from "react";
import BaseLayout from "../../components/BaseLayout";
import { Hidden } from "@material-ui/core";
import AdminPageFilter from "../../features/Admin/AdminPageFilter";
import Admin from "../../features/Admin";

function AdminPage() {
  return (
    <BaseLayout paddingTop>
      <Hidden smDown>
        <AdminPageFilter />
      </Hidden>

      <Admin />
    </BaseLayout>
  );
}

export default AdminPage;
